(() => {
  const menu = document.getElementById('alosh-menu');
  const trigger = document.querySelector('[data-menu-open]');
  if (menu && trigger) {
    trigger.addEventListener('click', () => {
      menu.showModal();
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    });
    menu.querySelector('[data-menu-close]').addEventListener('click', () => menu.close());
    menu.addEventListener('click', event => {
      const bounds = menu.getBoundingClientRect();
      if (event.target === menu && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) menu.close();
    });
    menu.addEventListener('close', () => {
      document.body.style.overflow = '';
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => menu.close()));
  }

  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    const option = event.target.selectedOptions[0];
    const panel = event.target.closest('.product-panel');
    panel.querySelector('[data-product-price]').textContent = option.dataset.price || '';
    const button = panel.querySelector('[data-add-button]');
    button.disabled = option.dataset.available !== 'true';
    button.textContent = button.disabled ? 'Sold out' : 'Add to bag';
  });

  function initialiseCookies(scope = document) {
    scope.querySelectorAll('[data-cookie-preferences]').forEach(form => {
      if (form.dataset.initialised) return;
      form.dataset.initialised = 'true';
      const status = form.querySelector('[data-cookie-status]');
      const buttons = [...form.querySelectorAll('button')];
      const keys = ['analytics', 'marketing', 'preferences'];
      const showUnavailable = () => {
        status.textContent = 'Privacy controls could not load. Please refresh this page or use the store’s cookie banner to manage your choices.';
        buttons.forEach(button => { button.disabled = true; });
      };
      const ready = error => {
        const privacy = window.Shopify?.customerPrivacy;
        if (error || !privacy) { showUnavailable(); return; }
        const hydrate = () => {
          const consent = privacy.currentVisitorConsent();
          keys.forEach(key => { form.elements[key].checked = consent[key] === 'yes'; });
        };
        hydrate();
        status.textContent = 'Choose which optional uses you allow. Essential services remain active.';
        buttons.forEach(button => { button.disabled = false; });
        function save(reject) {
          const consent = { sale_of_data: false };
          keys.forEach(key => { consent[key] = reject ? false : form.elements[key].checked; });
          buttons.forEach(button => { button.disabled = true; });
          status.textContent = 'Saving your preferences…';
          try {
            privacy.setTrackingConsent(consent, result => {
              if (result?.error) { showUnavailable(); return; }
              hydrate();
              status.textContent = 'Your preferences have been saved with Shopify. You can change them here at any time.';
              buttons.forEach(button => { button.disabled = false; });
            });
          } catch { showUnavailable(); }
        }
        form.addEventListener('submit', event => { event.preventDefault(); save(false); });
        form.querySelector('[data-cookie-reject]').addEventListener('click', () => save(true));
      };
      if (window.Shopify?.customerPrivacy) ready();
      else if (window.Shopify?.loadFeatures) window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], ready);
      else showUnavailable();
    });
  }
  initialiseCookies();
  document.addEventListener('shopify:section:load', event => initialiseCookies(event.target));

  const motion = window.matchMedia('(hover: hover) and (pointer: fine) and (prefers-reduced-motion: no-preference)');
  let active = null;
  let frame = 0;
  function reset() {
    cancelAnimationFrame(frame);
    active?.style.removeProperty('--depth-x');
    active?.style.removeProperty('--depth-y');
    active = null;
  }
  document.addEventListener('pointermove', event => {
    if (!motion.matches || event.pointerType === 'touch') return;
    const target = event.target.closest('.hero, .collection-card, .product-card, .editorial-main, .editorial-detail');
    if (target !== active) reset();
    if (!target) return;
    active = target;
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const bounds = target.getBoundingClientRect();
      target.style.setProperty('--depth-x', String(Math.max(-1, Math.min(1, (event.clientX - bounds.left) / bounds.width * 2 - 1))));
      target.style.setProperty('--depth-y', String(Math.max(-1, Math.min(1, (event.clientY - bounds.top) / bounds.height * 2 - 1))));
    });
  }, { passive: true });
  window.addEventListener('scroll', reset, { passive: true });
  window.addEventListener('blur', reset);
  document.documentElement.addEventListener('pointerleave', reset);
  motion.addEventListener('change', reset);
})();

document.addEventListener('DOMContentLoaded', () => {
  if (window.Shopify?.CountryProvinceSelector) document.querySelectorAll('[data-address-country]').forEach(country => {
    const suffix = country.id.replace('Country-', '');
    new window.Shopify.CountryProvinceSelector(country.id, 'Province-' + suffix, { hideElement: 'ProvinceWrap-' + suffix });
  });
});
document.addEventListener('click', event => {
  if (event.target.closest('[data-delete-address]') && !window.confirm('Delete this address?')) event.preventDefault();
});
